
angular.module('ecrd')
    .component('recordQueriesSummary', {
        controller: 'RecordQueriesSummaryController',
        templateUrl: 'modules/ecrd/components/queries/record-summary/template.html',
    });
